




import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageErrorIndex extends Vue {
}
